import { useGetReturnsIntakesByDriverQuery } from '../services';
import { ReturnsIntakeFilters } from '../models';

interface UseReturnsIntakesProps {
  filters: ReturnsIntakeFilters;
  page: number;
  pageSize: number;
}

const useReturnsIntakes = ({ filters, page, pageSize }: UseReturnsIntakesProps) => {
  const { data, isLoading } = useGetReturnsIntakesByDriverQuery({
    filters,
    paginated: { page, pageSize },
  });

  return {
    returnsIntakes: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
    isLoading,
  };
};

export default useReturnsIntakes;
